import { InjectionToken } from '@angular/core';

// TODO ppt: add values and documentation.
export interface ReportExportConfigurations {
  baseUrl: string;
  s3BucketImagesUrl: string;
  edpMultimediaURI: string;
}

export const REPORT_EXPORT_CONFIGS_TOKEN = new InjectionToken<ReportExportConfigurations>(
  'REPORT_EXPORT_CONFIGS_TOKEN'
);
